import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';

import { close } from './actions';
import { makeSelectRightModal } from './selectors';

import './right.scss';

const rightSideModal = WrappedComponent =>
  class extends React.Component {
    constructor(props) {
      super(props);
    }

    static propTypes = {
      title: PropTypes.string,
    };

    static defaultProps = {
      title: '',
    };

    render() {
      const { title, openModal } = this.props;

      return (
        <Modal
          isOpen={openModal}
          toggle={this.props.close}
          className="right-side-modal"
        >
          <div className="modal-header">
            <h5
              className="modal-title"
              toggle={this.props.close}
            >
              {title}
            </h5>
            <button
              className="close"
              type="button"
              onClick={this.props.closeModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <ModalBody className="component-modal-body">
            <WrappedComponent {...this.props} />
          </ModalBody>
        </Modal>
      );
    }
  };

rightSideModal.propTypes = {
  WrappedComponent: PropTypes.element,
  closeModal: PropTypes.function,
};

export function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => dispatch(close()),
  };
}

const mapStateToProps = createStructuredSelector({
  openModal: makeSelectRightModal(),
});

const withReducer = injectReducer({ key: 'modal', reducer });
const withSaga = injectSaga({ key: 'modal', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
  rightSideModal,
);
